import React from 'react'
// components
import Tooltip from '@mui/material/Tooltip'
// views
import { Row } from '../../views'
import { TextArea, Container, Placeholder } from './views'
// utils
import { getTextFromHtml } from 'utils/html'

interface Props {
  value: string
  cellId: string
  disabled: boolean
  maxLines?: number
  selectRow?: any
  isSelected?: boolean
  isRowHeader?: boolean
  isSelectable?: boolean
  onCellValueChange: (value: string) => void
}

const RowCell: React.FC<Props> = ({
  value = '',
  cellId,
  disabled,
  maxLines = 5,
  selectRow,
  isSelected,
  isRowHeader,
  isSelectable,
  onCellValueChange
}) => {
  const [focused, setFocused] = React.useState(false)

  const handleClick = (textArea: HTMLElement) => textArea && textArea.focus()

  const handleBlur = () => {
    setFocused(false)
    onCellValueChange(document.getElementById(`text-area-${cellId}`).innerHTML)

    const textArea = document.getElementById(`text-area-${cellId}`)

    textArea.scrollTop = 0
  }

  const handleFocus = () => setFocused(true)

  const handlePaste = (e: any) => {
    e.preventDefault()

    const text = e.clipboardData.getData('text/plain')

    const range = document.getSelection().getRangeAt(0)
    range.deleteContents()

    const textNode = document.createTextNode(text)
    range.insertNode(textNode)
    range.selectNodeContents(textNode)
    range.collapse(false)

    const selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
  }

  React.useEffect(() => {
    const container = document.getElementById(`container-${cellId}`)
    const textArea = document.getElementById(`text-area-${cellId}`)

    if (value) {
      textArea.innerHTML = value
    }

    if (disabled) return

    container.addEventListener('click', () => handleClick(textArea))
    textArea.addEventListener('paste', handlePaste)

    return () => {
      container.removeEventListener('click', () => handleClick(textArea))
      textArea.removeEventListener('paste', handlePaste)
    }
  }, [])

  return (
    (<Row onClick={selectRow} isSelected={isSelected} isSelectable={isSelectable} color={isSelected && '#2d323e'}>
      <Tooltip title={getTextFromHtml(value)} disableHoverListener={!value}>
        <Container id={`container-${cellId}`} isRowHeader={isRowHeader} withCursor={!disabled}>
          <TextArea
            focused={focused}
            onBlur={handleBlur}
            maxLines={maxLines}
            onFocus={handleFocus}
            id={`text-area-${cellId}`}
            contentEditable={!disabled}
          />
          {!focused && !value && <Placeholder>Enter text</Placeholder>}
        </Container>
      </Tooltip>
    </Row>)
  );
}

export default RowCell
